import React from "react";

export type GridOrder = {
    id: number;
    price: number;
    filled: boolean; // true — ордер сработал
    type: "BUY" | "SELL";
};

type GridLevelsBarProps = {
    currentPrice: number;
    orders: GridOrder[];
};

export const GridLevelsBar: React.FC<GridLevelsBarProps> = ({ currentPrice, orders }) => {
    const minPrice = Math.min(...orders.map(o => o.price));
    const maxPrice = Math.max(...orders.map(o => o.price));
    const range = maxPrice - minPrice || 1;

    const normalized = (price: number) => ((price - minPrice) / range) * 100;

    return (
        <div className="p-4 bg-white border rounded-xl shadow space-y-4">
            <div className="text-lg font-semibold mb-2">
                Текущая цена: <span className="text-blue-600">{currentPrice.toFixed(4)}</span>
            </div>

            <div className="relative h-60">
                {/* Линия */}
                <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200" />

                {/* Текущая цена */}
                <div
                    className="absolute w-0.5 bg-blue-600"
                    style={{ left: `${normalized(currentPrice)}%`, top: "10%", bottom: "10%" }}
                />

                {/* Точки ордеров */}
                {orders.map(order => (
                    <div
                        key={order.id}
                        className="absolute flex flex-col items-center"
                        style={{ left: `${normalized(order.price)}%`, top: "30%" }}
                    >
                        {/* Кружок */}
                        <div
                            className={`
                                w-5 h-5 rounded-full border-2 
                                ${order.filled
                                    ? order.type === "BUY"
                                        ? "bg-green-500 border-green-600"
                                        : "bg-red-500 border-red-600"
                                    : order.type === "BUY"
                                        ? "border-green-600"
                                        : "border-red-600"
                                }
                            `}
                        />

                        {/* Цена */}
                        <div className="mt-1 text-xs text-gray-700 font-medium">
                            {order.price.toFixed(2)}
                        </div>

                        {/* Тип */}
                        <div className="text-[10px] text-gray-500">
                            {order.type.toUpperCase()}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};